import {addClass, hasClass, normalizeData, removeClass} from "../../../../modules/vegas/js/util";

class SliderChanger {
	constructor(element) {
		this.swiperContainer = element;
		this.swiper = this.swiperContainer.swiper;
		this.tm = null;
		this.timeout = 0;
		this.slidersType = this.getSlidersType();

		this.pauseAll();
		this.addVideosListeners();

		this.swiper.on('slideChange', (swiper) => {
			this.initSlide(swiper.activeIndex);
		});


		this.initSlide(0);
	}

	getSlidersType() {
		return window.innerWidth > 767 ? 'desktop' : 'mobile';
	}

	pauseAll() {
		this.swiperContainer.querySelectorAll('video').forEach((video) => {
			video.pause();
		});
	}

	addVideosListeners() {
		this.swiperContainer.querySelectorAll('video').forEach((video) => {
			video.addEventListener('ended', () => {
				this.nextSlide();
			});
		})
	}

	initSlide(index) {
		this.pauseAll();
		clearTimeout(this.tm);

		let video = this.swiper.slides[index].querySelector(`[data-type=${this.slidersType}] video`);
		if (video) {
			video.play();
		} else {
			this.miniSlider(index)
		}
	}

	nextSlide() {
		if (this.swiper.slides[this.swiper.activeIndex + 1]) {
			this.swiper.slideNext();
		} else {
			this.swiper.slideTo(0);
		}
	}

	miniSlider(index) {
		const _this = this;

		let swiper = this.swiper,
			element = swiper.slides[index].querySelector('.slider-item'),
			slides = element.dataset.images || [],
			$_slides = [];

		slides = normalizeData(slides);

		if (slides.length) {
			let _stack = element.querySelector('.slider-item--image-stack');
			if (_stack) {
				_stack.innerHTML = '';
				let delay = 5000;

				$_slides = slides.map(function (el) {
					let mSlide = document.createElement('div');
					addClass(mSlide, 'stack');
					addClass(mSlide, 'd-none');

					let image = document.createElement('span');
					addClass(image, 'image');

					let img = document.createElement('img');
					img.setAttribute('data-src', el.photos.img);
					img.setAttribute('alt', '');
					addClass(img, 'swiper-lazy');

					if ('link' in el && el.link) {
						let link = document.createElement('a');
						link.setAttribute('href', el.link);
						link.append(img);
						image.append(link);
					} else {
						image.append(img);
					}

					mSlide.append(image);
					_stack.append(mSlide);

					return mSlide;
				});

				function rotator(i) {
					$_slides = $_slides.map(function (el) {
						if (hasClass(el, 'slide')) {
							removeClass(el, 'slide');
						}

						if (!hasClass(el, 'd-none')) {
							setTimeout(() => {
								addClass(el, 'd-none');
							}, 300);
						}

						return el;
					});

					let stack = $_slides[i];
					removeClass(stack, 'd-none');

					let stackImg = stack?.querySelector('img');
					if (stackImg) {
						stackImg.setAttribute('src', stackImg.dataset.src);
					}
					setTimeout(() => {
						addClass(stack, 'slide');
					}, 300);

					i++;
					if (i === $_slides.length) {
						setTimeout(() => {
							_this.nextSlide();
						}, 5000)
					}

					setTimeout(() => {
						rotator(i)
					}, delay);
				}

				rotator(0);
			}
		}
	}
}

function onReady() {
	const swiperContainer = document.querySelector('#swiper-slider');

	if (!swiperContainer) {
		return;
	}

	new SliderChanger(swiperContainer);
}

document.addEventListener('DOMContentLoaded', onReady);
